import { render, staticRenderFns } from "./KeywordManager.vue?vue&type=template&id=4d2ecec6&scoped=true&"
import script from "./KeywordManager.vue?vue&type=script&lang=js&"
export * from "./KeywordManager.vue?vue&type=script&lang=js&"
import style0 from "./KeywordManager.vue?vue&type=style&index=0&id=4d2ecec6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2ecec6",
  null
  
)

component.options.__file = "KeywordManager.vue"
export default component.exports